import { useQuery, keepPreviousData } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { searchLeads } from '../../api/leadSearchApi';

import { leadSearchKeys } from './keys';

export function useLeadSearch(q) {
	return useQuery({
		queryKey: leadSearchKeys.search(q),
		queryFn: () => searchLeads({ q }),
		enabled: q.trim().length >= 2,
		staleTime: STALE_TIMES.FREQUENT,
		placeholderData: keepPreviousData,
	});
}
